import React, { FC } from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  description: string;
  secondDescription: string;
  confirmText: string;
  show: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
};

export const ConfirmModal: FC<Props> = ({
  title,
  description,
  secondDescription,
  confirmText,
  show,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton className="border-0 text-dark ">
        <Modal.Title className="fs-3">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="mb-0">{description}</p>
        <p className="mb-0">{secondDescription}</p>
        <div className="row gx-2 mt-4">
          <div className="col-6">
            <Button
              variant="outline-danger"
              className="w-100 py-3"
              onClick={onConfirm}
            >
              {confirmText}
            </Button>
          </div>
          <div className="col-6">
            <Button
              variant="primary"
              className="w-100 py-3 fw-bold text-white"
              onClick={onCancel}
            >
              {t("profile.cancel")}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
